import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CommonInput from "../../../components/input/CommonInput";
import CommonButton from "../../../components/button/CommonButton";
import Card from "../../../components/card/Card";
import { appApiHandler } from "../../../api/appApiHandler";
import "./CreateSupportTicket.css";
import HomeHeader from "../../../components/header/HomeHeader";
import CommonFooter from "../../../components/footer/CommonFooter";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";
import { getErrorMessage } from "../../../constants/globalFunction";
import { string } from "../../../constants/string";
import Breadcrumb from "../../../components/breadcrumb";

const CreateSupportTicket = () => {
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.userState);

  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [subjectError, setSubjectError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [loading, setLoading] = useState(false);

  const validateValues = () => {
    let isValid = true;

    if (!subject.trim()) {
      setSubjectError("Please enter subject");
      isValid = false;
    } else {
      setSubjectError("");
    }

    if (!description.trim()) {
      setDescriptionError("Please enter description");
      isValid = false;
    } else {
      setDescriptionError("");
    }

    return isValid;
  };

  const onSubmit = async () => {
    const isValid = validateValues();
    if (isValid) {
      const reqData = {
        subject: subject.trim(),
        description: description.trim(),
        user_id: userData?._id,
      };
      setLoading(true);
      const response = await appApiHandler.raiseSupportTicket(reqData);
      setLoading(false);
      if (response?.status === 200) {
        showSuccessToast('Ticket raised successfully');
        navigate("/support-tickets");
      } else if (response?.message) {
        showErrorToast(getErrorMessage(response?.message));
      } else {
        showErrorToast(string.error.failed_due_to_internal_error);
      }
    }
  };

  return (
    <div className="create-ticket-container">
      <HomeHeader />
      <Breadcrumb
        items={[
          {
            label: "Home",
            path: "/",
          },
          {
            label: "Support Tickets",
            path: "/support-tickets",
          },
          {
            label: "Create Ticket",
            isActive: true,
          },
        ]}
      />

      <div className="create-ticket-content">
        <Card
          className="create-ticket-card"
          padding="32px"
          maxWidth="600px"
          centered={true}
        >
          <div className="form-container">
            <CommonInput
              label="Subject"
              value={subject}
              onChange={setSubject}
              error={subjectError}
              editable={!loading}
              placeholder="Enter subject"
            />
            <CommonInput
              label="Description"
              value={description}
              onChange={setDescription}
              error={descriptionError}
              editable={!loading}
              placeholder="Enter description"
              multiline={true}
            />
          </div>
          <CommonButton
            title={loading ? "Submitting..." : "Submit"}
            onPress={onSubmit}
            disabled={loading}
            customClassName="submit-btn"
          />
        </Card>
      </div>
      <CommonFooter />
    </div>
  );
};

export default CreateSupportTicket;
